import { render, staticRenderFns } from "./StoreProducts.vue?vue&type=template&id=0407e8a8"
import script from "./StoreProducts.vue?vue&type=script&lang=js"
export * from "./StoreProducts.vue?vue&type=script&lang=js"
import style0 from "./StoreProducts.vue?vue&type=style&index=0&id=0407e8a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports